<template>
  <div id="contenedor-switch-completar-actividad">
    <v-form v-model="esformularioValido" ref="completarActividad">
      <v-row justify="center">
        <v-switch v-model="actividad.completa" @change="actividadCompleta" inset> </v-switch>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import mixActividades from './mixActividades';

export default {
  name: 'SwitchCompletarActividad',
  mixins: [mixActividades],
  props: {
    actividadEditar: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      enviandoFormulario: false,
      esformularioValido: false,
      actividad: {
        completa: this.actividadEditar.completa,
      },
    };
  },
  methods: {
    actividadCompleta() {
      this.mixActualizarActividad();
    },
    cerrar() {
    },
  },

};
</script>

<style>

</style>
